"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderIf;

var defaultNegative = function defaultNegative() {
  return null;
};
/**
 * util for rendering jsx if conditional is met
 *
 * @param conditional - conditional to evaluate
 * @param affirmative - function to execute if conditional === true
 * @param negative - function to execute if conditional === false
 */


function renderIf(conditional, affirmative) {
  var negative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultNegative;
  return conditional ? affirmative() : negative();
}